const searchFormValue = {
    search: null
};

const operatorOptions = [
    { text: '선택해주세요.', value: null, disabled: true },
    { text: '==(같음)', value: '==' },
    { text: '!=(다름)', value: '!=' },
    { text: '<(작음)', value: '<' },
    { text: '≤(작거나 같음)', value: '<=' },
    { text: '>(큼)', value: '>' },
    { text: '≥(크거나 같음)', value: '>=' },
    { text: 'IN(포함)', value: 'IN' },
];

const columns = [
    {
        key: 'index',
        label: '번호',
        thStyle: {
            width: '60px'
        },
        thClass: ['mb-0','th-center'],
        tdClass: ['td-center'],
    },
    {
        key: 'name',
        label: '조건명',
        thStyle: {
            width: '100px'
        },
        thClass: ['mb-0','th-left'],
        tdClass: ['td-left', 'text-truncate'],
    },
    {
        key: 'key',
        label: '조건 키',
        thStyle: {
            width: '100px'
        },
        thClass: ['mb-0','th-left'],
        tdClass: ['td-left', 'text-truncate'],
    },
    {
        key: 'operator',
        label: '연산자',
        thStyle: {
            width: '60px'
        },
        thClass: ['mb-0','th-center'],
        tdClass: ['td-center'],
    },
    {
        key: 'detail',
        label: '상세',
        thStyle: {
            width: '60px'
        },
        thClass: ['mb-0','th-center'],
        tdClass: ['td-center'],
    },
    {
        key: 'updated_at',
        label: '수정일시',
        thStyle: {
            width: '160px'
        },
        thClass: ['mb-0','th-center'],
        tdClass: ['td-center'],
    },
];

// 조건 관리 탭 목록(DS 표 규칙). 위 columns 는 조건 선택 창(ConditionSearchModal)이 그대로 쓴다.
// No. 는 표시 순서(페이지를 넘어 이어짐, fetchData 에서 매김) — 식별자가 아니다
const listColumns = [
    {key: 'index', label: 'No.', thClass: 'ds-cell-no', tdClass: 'ds-cell-no', thStyle: {width: '64px'}},
    {key: 'name', label: '조건명'},
    {key: 'key', label: '조건 키'},
    {key: 'operator', label: '연산자', thStyle: {width: '88px'}},
    {key: 'updated_at', label: '수정일시', tdClass: 'ds-cell-nowrap', thStyle: {width: '160px'}},
    // 아이콘 28 + 좌우 16 = 60
    {key: 'detail', label: '상세', tdClass: 'text-right', thStyle: {width: '60px'}},
];

export { searchFormValue, columns, listColumns, operatorOptions};
